var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { HttpClient } from '@angular/common/http';
import { ElementRef, NgZone, OnInit, ChangeDetectorRef, Renderer2 } from '@angular/core';
import { NavigationEnd, NavigationStart, NavigationCancel, NavigationError, Router, ActivatedRoute, RouterEvent } from '@angular/router';
import { environment } from '@environments/environment';
import { SidebarService, ModalService } from '@ibe/services/ui';
import { Store } from '@ngrx/store';
import { Subject, Observable, Subscription } from 'rxjs';
import { debounceTime, filter, map, mergeMap, take } from 'rxjs/operators';
import { AppComponent } from './app.component';
import * as fromStore from './store';
import * as CountryCodesActions from './store/actions/country-code.action';
import { Title } from '@angular/platform-browser';
import { INDRAIbeAdminConfigService } from '@ibe.services/ibeadmin-config.service';
import { INDRAExpirateAlertComponent } from '@ibe.components/shared/expirate-alert/expirate-alert.indra.component';
import { TimeoutSvcService } from '@ibe.services/timeout-svc.service';
import { INDRAGoogleAnalyticsService } from '@ibe.services/google.analytics.indra.service';
import { INDRAApiService, INDRAAuthenticationService } from '@ibe/services';
import * as ModalActions from './store/actions/modal.actions';
import { LOCAL_STORAGE_VAR_KEY_DONT_REDIRECT, TRANSLATION_MODULES_SEARCH_PAGE, LOCAL_STORAGE_VAR_KEY_ROUTE_NAME, PAYMENT_LOGIN_STATE_ROUTE_NAME, PAYMENT_PASSENGERS_STATE_ROUTE_NAME, PAYMENT_CONTACTS_STATE_ROUTE_NAME, PAYMENT_PAYMENT_STATE_ROUTE_NAME, } from '@ibe.config';
import { Location } from '@angular/common';
import { INDRALanguageMarketService } from '@ibe.services/language-market-indra.service';
import { INDRAURLService } from '@ibe.services/url.indra.service';
import { INDRALocationService } from '@ibe.services/location.indra.service';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
import { DEFAULT_MARKET } from '@ibe.config';
import * as UserActions from '@ibe/store/actions/user.actions';
import { INDRASessionTimeoutModalComponent } from '@ibe.components/shared/session-timeout-modal/session-timeout-modal.indra.component';
import { INDRADeepLinkService } from '@ibe.services/deeplink.indra.service';
import { INDRAStorageService } from '@ibe.services/storage.indra.service';
import { INDRACookieService } from '@ibe.services/cookie.indra.service';
var INDRAAppComponent = /** @class */ (function (_super) {
    __extends(INDRAAppComponent, _super);
    /*
    @HostListener('window:unload', ['$event'])
    unloadHandler(event) {
        console.log('unloaded');
        //return false;
    }
    
    @HostListener('window:closed', ['$event'])
    closedHandler(event) {
        console.log('closing');
        alert('test');
        //return false;
    }

    @HostListener('window:beforeunload', ['$event'])
    beforeUnloadHandler(event) {
        // call api to remove amadeus session in the backend
        // this.apiService.INDRA_signOutFromSession();
        // console.log('beforeunload');
    }
    */
    function INDRAAppComponent(document, sidebarService, router, activatedRoute, zone, store, elRef, gaService, ibeAdminConfigService, _http, titleService, modalService, changeRef, timeoutSvc, apiService, location, languageMarketService, urlService, locationService, ibeAdminService, deeplinkService, renderer, storage, authenticationService, cookieService) {
        var _this = _super.call(this) || this;
        _this.document = document;
        _this.sidebarService = sidebarService;
        _this.router = router;
        _this.activatedRoute = activatedRoute;
        _this.zone = zone;
        _this.store = store;
        _this.elRef = elRef;
        _this.gaService = gaService;
        _this.ibeAdminConfigService = ibeAdminConfigService;
        _this._http = _http;
        _this.titleService = titleService;
        _this.modalService = modalService;
        _this.changeRef = changeRef;
        _this.timeoutSvc = timeoutSvc;
        _this.apiService = apiService;
        _this.location = location;
        _this.languageMarketService = languageMarketService;
        _this.urlService = urlService;
        _this.locationService = locationService;
        _this.ibeAdminService = ibeAdminService;
        _this.deeplinkService = deeplinkService;
        _this.renderer = renderer;
        _this.storage = storage;
        _this.authenticationService = authenticationService;
        _this.cookieService = cookieService;
        _this.yScrollStack = [];
        _this.scrollSubject = new Subject();
        _this.isMobile$ = _this.store.select(fromStore.isScreenMobile);
        _this.isMobile = false;
        _this.selectedMarketCode = null;
        _this.selectedLanguageCode = null;
        _this.isRefresh = false;
        _this.scrollToHideHeaderRoutes = [
            '/booking/dates',
            '/booking/flights',
            // '/booking/review-your-trip',
            '/booking/extras-to-your-trip',
            '/booking/payment',
            // '/booking/time-to-think',
            '/corporate/dates',
            '/corporate/flights',
            '/corporate/review-your-trip',
            '/corporate/extras-to-your-trip',
            '/corporate/payment',
            '/corporate/time-to-think'
        ];
        _this.allSubscriptions = [];
        _this._counter = 0;
        _this._status = 'Initialized.';
        _this.navigationLoading = false;
        _this.isDeepLink = false;
        _this.configReady = false;
        _this.headerFooterHidden = false;
        _this.skipRenew = false;
        _this.isOtherAPILoading = false;
        _this.tabId = Date.now().toString();
        _this.selectedCountryIndex = 1;
        _this.countriesList = [
            {
                image: 'flags--flag-brazil',
                country: 'Brazil',
                code: 'BR',
                language: [{ label: 'Português', code: 'pt' }, { label: 'English', code: 'en' }]
            },
            {
                image: 'flags--flag-portugal',
                country: 'Portugal',
                code: 'PT',
                language: [{ label: 'Português', code: 'pt' }, { label: 'English', code: 'en' }]
            },
            {
                image: 'flags--flag-spain',
                country: 'Spain',
                code: 'ES',
                language: [{ label: 'Español', code: 'es' }, { label: 'English', code: 'en' }]
            }
        ];
        _this.pageJustLoaded = true;
        _this.cargado = false;
        _this.TAP_setPageTitle();
        _this.isMobile$
            .subscribe(function (value) {
            _this.isMobile = value;
        });
        router.events.subscribe(function (routerEvent) {
            _this.isDeepLink = router.url.includes('deeplink') ? true : false;
            _this.headerFooterHidden = _this.deeplinkService.headerFooterHidden;
            if (routerEvent instanceof NavigationStart) {
                _this.navigationLoading = true;
            }
            else if (routerEvent instanceof NavigationEnd ||
                routerEvent instanceof NavigationCancel ||
                routerEvent instanceof NavigationError) {
                _this.navigationLoading = false;
            }
        });
        _this._skipRenewSession = _this.timeoutSvc.skipRenewSession$.subscribe(function (val) {
            _this.skipRenew = val;
        });
        _this._otherAPILoading = _this.timeoutSvc.isOtherAPILoading$.subscribe(function (value) {
            _this.isOtherAPILoading = value;
        });
        _this.allSubscriptions.push(_this._skipRenewSession);
        _this.allSubscriptions.push(_this._otherAPILoading);
        return _this;
    }
    INDRAAppComponent.prototype.onScroll = function () {
        var top = window.scrollY === undefined ? window.pageYOffset : window.scrollY;
        if (top > 0) {
            this.elRef.nativeElement.className += this.elRef.nativeElement.className.includes('scrolled') ? '' : 'scrolled';
        }
        else {
            this.elRef.nativeElement.className = this.elRef.nativeElement.className.replace('scrolled', '');
        }
    };
    INDRAAppComponent.prototype.updateScroll = function (e) {
        this.scrollSubject.next(e);
    };
    /**
     * Sets base url to the environment's configuration
     */
    INDRAAppComponent.prototype.setBaseHref = function () {
        var bases = this.document.getElementsByTagName('base');
        if (bases.length > 0) {
            bases[0].setAttribute('href', environment.base_href);
        }
    };
    INDRAAppComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var currentUrl, self;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        window.addEventListener('beforeunload', this.beforeUnloadHandler.bind(this));
                        currentUrl = window.location.href;
                        if (localStorage.getItem(LOCAL_STORAGE_VAR_KEY_DONT_REDIRECT) &&
                            localStorage.getItem(LOCAL_STORAGE_VAR_KEY_ROUTE_NAME) &&
                            (currentUrl.includes(localStorage.getItem(LOCAL_STORAGE_VAR_KEY_ROUTE_NAME)) ||
                                (localStorage.getItem(LOCAL_STORAGE_VAR_KEY_ROUTE_NAME).includes(PAYMENT_PAYMENT_STATE_ROUTE_NAME) &&
                                    (currentUrl.includes(PAYMENT_PAYMENT_STATE_ROUTE_NAME) ||
                                        currentUrl.includes(PAYMENT_LOGIN_STATE_ROUTE_NAME) ||
                                        currentUrl.includes(PAYMENT_PASSENGERS_STATE_ROUTE_NAME) ||
                                        currentUrl.includes(PAYMENT_CONTACTS_STATE_ROUTE_NAME))))) {
                            this.isRefresh = true;
                        }
                        this.tabId = Date.now().toString();
                        if (sessionStorage.getItem('currTabId') == "null" || sessionStorage.getItem('currTabId') == null) {
                            sessionStorage.setItem('currTabId', this.tabId);
                        }
                        else {
                            if (window.performance.navigation.type === 0) {
                                this.routerEvent = true;
                            }
                            else {
                                this.routerEvent = false;
                            }
                            this.INDRA_CheckTabUniqueness();
                        }
                        return [4 /*yield*/, this.INDRA_setCurrentMarketAndLanguage(false, this.isRefresh)];
                    case 1:
                        _a.sent();
                        self = this;
                        // Avoid over calculations from Angular by checking for changes on scroll
                        // this.zone.runOutsideAngular(() => {
                        // 	window.addEventListener('scroll', this.updateScroll.bind(self));
                        // });
                        this.zone.run(function () {
                            window.addEventListener('scroll', _this.updateScroll.bind(self));
                            _this.scrollSubject.pipe(debounceTime(75)).subscribe(function () { return (_this.onScroll.bind(self))(); });
                            _this.setBaseHref();
                            _this.scrollController();
                            _this.gaService.subscribe();
                            var url = window.location.href;
                            if (!url.includes('/deeplink')) {
                                _this._ibeAdminConfigSubscription = _this.ibeAdminConfigService.loadConfigurations('tap', ['externalURLs', 'insurance', 'Search', 'bookingSearch', 'bookingPayment']).subscribe(function (value) {
                                    var key = 'bookingSearch.appAvailable';
                                    _this.cargado = true;
                                    if (value) {
                                        _this.INDRA_disableVWOScript();
                                        var key_1 = 'bookingSearch.appAvailable';
                                        var isAppAvailable = _this.ibeAdminConfigService.getConfigurationValue(key_1);
                                        if (isAppAvailable === 'false') {
                                            _this.router.navigate(['/notavailable']);
                                        }
                                        var sessionTimeoutInSeconds = _this.ibeAdminConfigService.getConfigurationValue('bookingSearch.sessionTimeoutInSeconds');
                                        var sessionTimeoutTimeRemainingInSeconds = _this.ibeAdminConfigService.getConfigurationValue('bookingSearch.sessionTimeoutTimeRemainingInSeconds');
                                        if (sessionTimeoutInSeconds) {
                                            _this.timeoutSvc.INDRA_setSessionTimeoutInSeconds(Number(sessionTimeoutInSeconds));
                                        }
                                        if (sessionTimeoutTimeRemainingInSeconds) {
                                            _this.timeoutSvc.INDRA_setSessionTimeoutTimeRemainingInSeconds(Number(sessionTimeoutTimeRemainingInSeconds));
                                        }
                                    }
                                    _this.configReady = true;
                                }, function (error) {
                                    _this.configReady = true;
                                });
                            }
                            else {
                                _this._ibeAdminConfigSubscription = _this.ibeAdminConfigService.loadConfigurations('tap', ['bookingSearch']).subscribe(function (value) {
                                    if (value) {
                                        _this.INDRA_disableVWOScript();
                                    }
                                });
                                _this.configReady = true;
                            }
                            _this.getCountryCodes();
                            _this.INDRA_checkSessionStart();
                            _this.allSubscriptions.push(_this._ibeAdminConfigSubscription);
                            _this.allSubscriptions.push(_this._idleTimerSubscription);
                        });
                        // When app is loaded, reset all existing dialog from other tab
                        // or from previous known state that opens the dialog
                        this.store.dispatch(new UserActions.PutConfirmDialogAction(false));
                        return [2 /*return*/];
                }
            });
        });
    };
    INDRAAppComponent.prototype.INDRA_CheckTabUniqueness = function () {
        if (this.routerEvent) {
            sessionStorage.setItem('currTabId', this.tabId);
        }
        else {
            var currTabId = sessionStorage.getItem('currTabId');
            if (currTabId !== this.tabId) {
                this.location.replaceState('booking');
                this.apiService.INDRA_createNewSession();
                sessionStorage.setItem('currTabId', this.tabId);
            }
        }
    };
    /**
     * * Get list of countries with phone codes from file
     * */
    INDRAAppComponent.prototype.getCountryCodes = function () {
        var _this = this;
        var URL = './assets/data/country_codes.json';
        var filePromise = this._http.get(URL).toPromise();
        filePromise.then(function (data) {
            _this.store.dispatch(new CountryCodesActions.PutCountryCodesAction(data));
        }, function (err) {
            console.error(err);
        });
    };
    /**
     * Subscribes to router events to scroll to top on new pages
     * and scroll back to the previous state on previous pages.
     */
    INDRAAppComponent.prototype.scrollController = function () {
        var _this = this;
        this.lastPoppedUrl = undefined;
        this.router.events.subscribe(function (ev) {
            // TODO - Improve to open sidebar on load
            // Remove Side bar from URL on page load
            if (_this.pageJustLoaded && ev.url && ev.url.includes('sidebar:') && !_this.isRefresh) {
                _this.sidebarService.openSidebar();
                // this.sidebarService.closeSidebar();
                // this.router.navigate([ev.url.replace(/\s*\(.*?\)\s*/g, '')]);
            }
            _this.pageJustLoaded = false;
            if (ev instanceof NavigationStart) {
                // Save state of the url that router is leaving
                if (ev.url !== _this.lastPoppedUrl) {
                    _this.yScrollStack.push(window.scrollY);
                }
            }
            else if (ev instanceof NavigationEnd) {
                // Don't change update/change values/scroll on sidebars
                if (_this.lastPoppedUrl === undefined ||
                    (!ev.url.includes('sidebar:') &&
                        !_this.lastPoppedUrl.includes('sidebar:'))) {
                    // check if comming back to a saved url
                    if (ev.url === _this.lastPoppedUrl) {
                        window.scrollTo(0, _this.yScrollStack.pop());
                        // if going to new (not saved) url
                    }
                    else {
                        _this.INDRA_scrollToTop();
                    }
                }
                // Save url that router is leaving
                _this.lastPoppedUrl = ev.url;
            }
        });
    };
    INDRAAppComponent.prototype.TAP_setPageTitle = function () {
        var _this = this;
        this.router.events.pipe(filter(function (event) { return event instanceof NavigationEnd; }), map(function () { return _this.activatedRoute; }), map(function (route) {
            while (route.firstChild)
                route = route.firstChild;
            return route;
        }), filter(function (route) { return route.outlet === 'primary'; }), mergeMap(function (route) { return route.data; })).subscribe(function (event) {
            if (event['title']) {
                _this.titleService.setTitle(event['title']);
            }
            else {
                _this.titleService.setTitle('TAP Air Portugal');
            }
        });
    };
    INDRAAppComponent.prototype.INDRA_scrollToTop = function () {
        var _this = this;
        clearTimeout(this.scrollToTopTimeout); // needed for every route change
        this.scrollToTopTimeout = setTimeout(function () {
            var routerTree = _this.router.parseUrl(_this.router.url);
            routerTree.queryParams = {};
            var routeUrl = routerTree.toString();
            if (_this.scrollToHideHeaderRoutes.filter(function (route) { return routeUrl === route; }).length > 0) {
                var headerMobileHeight = 54;
                var headerDesktopHeight = 64;
                var headerHeight = _this.isMobile ? headerMobileHeight : headerDesktopHeight;
                window.scrollTo(0, headerHeight);
            }
            else {
                window.scrollTo(0, 0);
            }
        }, 10);
    };
    INDRAAppComponent.prototype.ngOnDestroy = function () {
        window.removeEventListener('beforeunload', this.beforeUnloadHandler.bind(this));
        for (var _i = 0, _a = this.allSubscriptions; _i < _a.length; _i++) {
            var sub = _a[_i];
            if (sub) {
                sub.unsubscribe();
            }
        }
    };
    INDRAAppComponent.prototype.INDRA_sessionTimeout = function () {
        if (this.router.url === '/booking' || this.router.url === '/' || this.router.url === '/notavailable') {
            this.timeoutSvc.sessionRenew();
            this.timeoutSvc.resetTimer();
        }
        else {
            if (!this.skipRenew) {
                if (this.timeoutSvc.renewLimitReached) {
                    this.timeoutSvc.renewLimitReached = false;
                    this.modalService.assignComponent(INDRASessionTimeoutModalComponent);
                }
                else {
                    this.modalService.assignComponent(INDRAExpirateAlertComponent);
                }
                this.modalService.open();
                this.store.dispatch(new ModalActions.PutShowCloseAction(false));
            }
        }
    };
    INDRAAppComponent.prototype.INDRA_checkSessionStart = function () {
        var _this = this;
        this._idleTimerSubscription = this.timeoutSvc.timeoutExpired.subscribe(function (res) {
            // if other API is waiting to complete,
            // extend timer by 1 minute
            if (_this.isOtherAPILoading) {
                _this.timeoutSvc.INDRA_extendTimer();
            }
            else {
                _this.INDRA_sessionTimeout();
            }
        });
        this.router.events.subscribe(function (ev) {
            if (ev instanceof NavigationEnd) {
                if (_this.router.url === '/booking' || _this.router.url === '/' || _this.router.url === '/notavailable') {
                    _this.timeoutSvc.stopTimer();
                }
            }
        });
    };
    INDRAAppComponent.prototype.INDRA_disableVWOScript = function () {
        var isVwoEnabled = this.ibeAdminConfigService.getConfigurationValue('bookingSearch.vwoEnabled');
        if (isVwoEnabled !== 'true') {
            var vwoScript = this.renderer.selectRootElement('#vwoCode', true);
            if (vwoScript) {
                this.renderer.removeChild(vwoScript.parentNode, vwoScript);
            }
        }
    };
    INDRAAppComponent.prototype.awaitableObservable = function (observable) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        observable.pipe(take(1)).subscribe(function (result) {
                            resolve(result);
                        }, function (error) {
                            reject(error);
                        });
                    })];
            });
        });
    };
    INDRAAppComponent.prototype.INDRA_setCurrentMarketAndLanguage = function (bypassQuery, loadSearchPage) {
        if (bypassQuery === void 0) { bypassQuery = false; }
        if (loadSearchPage === void 0) { loadSearchPage = false; }
        return __awaiter(this, void 0, void 0, function () {
            var queryMarketCode, queryLanguageCode, markets, market, markets, market, defaultlangMarket_1, markets, market, defaultCountry, error_1, defaultCountry;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryMarketCode = this.urlService.INDRA_getUrlParams('market', window.location.href);
                        queryLanguageCode = this.getLanguageFromSpecialMarketRules(queryMarketCode, this.urlService.INDRA_getUrlParams('language', window.location.href));
                        this.selectedMarketCode = sessionStorage.getItem('market');
                        this.selectedLanguageCode = sessionStorage.getItem('language');
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 11, , 12]);
                        if (!(queryMarketCode && !bypassQuery)) return [3 /*break*/, 6];
                        this.selectedMarketCode = queryMarketCode.toUpperCase();
                        return [4 /*yield*/, this.languageMarketService.getMarkets().toPromise()];
                    case 2:
                        markets = _a.sent();
                        market = markets.find(function (item) { return item.marketCode === _this.selectedMarketCode; });
                        if (!market) return [3 /*break*/, 3];
                        if (queryLanguageCode) {
                            this.selectedLanguageCode = queryLanguageCode;
                            if (!market.locales.includes(this.selectedLanguageCode)) {
                                this.selectedLanguageCode = market.locales[0] || 'en';
                            }
                        }
                        else {
                            this.selectedLanguageCode = market.locales[0] || 'en';
                        }
                        this.setMarketSubscription = this.locationService.INDRA_setBookingMarket(this.selectedMarketCode, this.selectedLanguageCode).subscribe();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, this.INDRA_setCurrentMarketAndLanguage(true)];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [3 /*break*/, 10];
                    case 6:
                        if (!this.selectedMarketCode) return [3 /*break*/, 8];
                        return [4 /*yield*/, this.languageMarketService.getMarkets().toPromise()];
                    case 7:
                        markets = _a.sent();
                        market = markets.find(function (item) { return item.marketCode === _this.selectedMarketCode; });
                        if (market) {
                            if (queryLanguageCode) {
                                this.selectedLanguageCode = queryLanguageCode;
                            }
                            // If language code is not from query and
                            // If language code is not in session
                            // Or if it is indeed in session but invalid for selected market
                            // Then get the default language of the selected market
                            if (!this.selectedLanguageCode || !market.locales.includes(this.selectedLanguageCode)) {
                                this.selectedLanguageCode = market.locales[0] || 'en';
                            }
                        }
                        else {
                            this.selectedMarketCode = null;
                        }
                        _a.label = 8;
                    case 8:
                        if (!!this.selectedMarketCode) return [3 /*break*/, 10];
                        defaultlangMarket_1 = this.languageMarketService.loadDefaultLanguageMarket();
                        return [4 /*yield*/, this.languageMarketService.getMarkets().toPromise()];
                    case 9:
                        markets = _a.sent();
                        market = markets.find((function (item) { return item.marketCode === defaultlangMarket_1[1]; }));
                        if (market) {
                            this.selectedMarketCode = market.marketCode;
                            if (queryLanguageCode) {
                                this.selectedLanguageCode = queryLanguageCode;
                            }
                            // If language code is not from query and
                            // If language code is not in session
                            // Or if it is indeed in session but invalid for selected market
                            // Then get the default language of the selected market
                            if (!this.selectedLanguageCode || !market.locales.includes(this.selectedLanguageCode)) {
                                this.selectedLanguageCode = market.locales[0] || 'en';
                            }
                        }
                        else {
                            defaultCountry = this.countriesList.find(function (country) { return country.code === DEFAULT_MARKET; });
                            if (defaultCountry) {
                                this.selectedMarketCode = defaultCountry.code;
                                if (queryLanguageCode) {
                                    this.selectedLanguageCode = queryLanguageCode;
                                }
                                if (!this.selectedLanguageCode || !defaultCountry.language.find(function (language) { return language.code === _this.selectedLanguageCode; })) {
                                    this.selectedLanguageCode = defaultCountry.language[0].code || 'en';
                                }
                            }
                        }
                        this.setMarketSubscription = this.locationService.INDRA_setBookingMarket(this.selectedMarketCode, this.selectedLanguageCode).subscribe();
                        _a.label = 10;
                    case 10:
                        this.languageMarketService.setMarket(this.selectedMarketCode);
                        this.languageMarketService.setLanguage(this.selectedLanguageCode);
                        if (!loadSearchPage) {
                            this.ibeAdminService.loadTranslations('tap', ['header'], this.selectedLanguageCode);
                        }
                        else {
                            this.ibeAdminService.loadTranslations('tap', TRANSLATION_MODULES_SEARCH_PAGE, this.selectedLanguageCode);
                        }
                        return [3 /*break*/, 12];
                    case 11:
                        error_1 = _a.sent();
                        defaultCountry = this.countriesList[this.selectedCountryIndex];
                        this.selectedMarketCode = defaultCountry.code;
                        this.selectedLanguageCode = defaultCountry.language[0].code || 'pt';
                        this.languageMarketService.setMarket(this.selectedMarketCode);
                        this.languageMarketService.setLanguage(this.selectedLanguageCode);
                        if (!loadSearchPage) {
                            this.ibeAdminService.loadTranslations('tap', ['header'], this.selectedLanguageCode);
                        }
                        else {
                            this.ibeAdminService.loadTranslations('tap', TRANSLATION_MODULES_SEARCH_PAGE, this.selectedLanguageCode);
                        }
                        this.setMarketSubscription = this.locationService.INDRA_setBookingMarket(this.selectedMarketCode, this.selectedLanguageCode).subscribe();
                        console.log("Error while getting market", error_1);
                        return [3 /*break*/, 12];
                    case 12: return [2 /*return*/];
                }
            });
        });
    };
    INDRAAppComponent.prototype.beforeUnloadHandler = function (event) {
        if (this.sidebarService.isSidebarOpen) {
            this.sidebarService.close();
        }
        sessionStorage.setItem('currTabId', null);
    };
    INDRAAppComponent.prototype.getLanguageFromSpecialMarketRules = function (market, language) {
        if (!language) {
            return null;
        }
        language = language.toLowerCase();
        if (language === 'pt' && market === 'BR') {
            return 'pt-br';
        }
        if (language === 'pt-br' && market !== 'BR') {
            return 'pt';
        }
        var marketsForSpecialEnUSRule = ['CA', 'DO', 'MX', 'PA', 'US', 'UY'];
        if (language === 'en' && marketsForSpecialEnUSRule.includes(market)) {
            return 'en-us';
        }
        if (language === 'en-us' && !marketsForSpecialEnUSRule.includes(market)) {
            return 'en';
        }
        return language;
    };
    return INDRAAppComponent;
}(AppComponent));
export { INDRAAppComponent };
